import { RootState } from "redux-features/store";

export const selectAuthToken = (state: RootState) => state.auth.token;
export const selectAuthError = (state: RootState) => state.auth.errorMessage;
